import { gql } from 'apollo-angular'

export default gql`
  query selfStatus($id: Int!) {
    user_by_pk(id: $id) {
      id
      status
    }
  }
`
